import type { FeatureModule, FeatureState } from '../types';

type SaturationMode = 'off' | 'low' | 'grayscale' | 'high';

export default function createSaturationModule(): FeatureModule {
  let currentMode: SaturationMode = 'off';
  const STYLE_ID = 'accessify-saturation';
  const STORAGE_KEY = 'accessify-saturation-mode';

  function getStyles(mode: SaturationMode): string {
    switch (mode) {
      case 'low':
        return 'html { filter: saturate(0.3) !important; }';
      case 'grayscale':
        return 'html { filter: grayscale(1) !important; }';
      case 'high':
        return 'html { filter: saturate(1.8) !important; }';
      default:
        return '';
    }
  }

  function applyStyles(mode: SaturationMode) {
    let styleEl = document.getElementById(STYLE_ID);
    if (mode === 'off') {
      styleEl?.remove();
      return;
    }
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = STYLE_ID;
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = getStyles(mode);
  }

  function activate() {
    const saved = localStorage.getItem(STORAGE_KEY) as SaturationMode;
    currentMode = saved || 'grayscale';
    applyStyles(currentMode);
  }

  function deactivate() {
    currentMode = 'off';
    applyStyles('off');
    localStorage.removeItem(STORAGE_KEY);
  }

  return {
    id: 'saturation',
    name: () => 'Saturation',
    description: 'Adjust color saturation or grayscale',
    icon: 'saturation',
    category: 'visual',
    activate,
    deactivate,
    getState: (): FeatureState => ({ id: 'saturation', enabled: currentMode !== 'off', value: currentMode }),
    setState: (mode: SaturationMode) => {
      currentMode = mode;
      applyStyles(mode);
      localStorage.setItem(STORAGE_KEY, mode);
    },
  };
}
